export const sortByNameAsc = <T extends { name: string }>(items: T[]): T[] => {
  return items.sort((item1, item2) => {
    return item1.name.localeCompare(item2.name);
  });
};
